import { reservar_vaga_aluno } from "./reservar-vaga-aluno";
import { matricula_sem_reserva } from "./matricula-sem-reserva";

const reserva_de_vaga = [reservar_vaga_aluno, matricula_sem_reserva];

export { reserva_de_vaga };
